import "./style";

console.warn("Container controller file");

/* jslint browser: true,  devel: true */
var ContainerCtrl = [
  "$scope",
  "$rootScope",
  "$element",
  "$state",
  "$ocLazyLoad",
  "$utils",
  "api",
  "$templateCache",
  function(
    $scope,
    $rootScope,
    $element,
    $state,
    $ocLazyLoad,
    $utils,
    api,
    $templateCache
  ) {
    console.log("ContainerCtrl:init");
    var utils = $utils($scope, true);
    $scope.$state = $state;

    $scope.goApp = app => {
      if (app.href) {
        if (app.href[0] === "#" || app.href[0] === "/") {
          // TODO try to use states when given rel urls
          window.location.href = app.href;
        } else {
          window.open(app.href);
        }
        return;
      }
      const stateName = app.bundleName
        ? `${app.bundleName}-async`
        : app.appName;
      const target = $state.get(stateName);
      if (target) {
        return $state.go(stateName);
      }
      return $state.go("placeholder", {
        $app: {
          title: app.appName.charAt(0).toUpperCase() + app.appName.slice(1)
        }
      });
    };

    $scope.logout = function() {
      api.Login.logout();
    };

    $element.on("$destroy", function() {
      setTimeout(function() {
        $scope.$destroy();
      }, 1);
    });

    if (!$scope.enterpriseConfig) {
      $scope.$refreshConfig().then(function(enterpriseConfig) {
        document.title = enterpriseConfig.appName || "";
        utils.broadcast("$refresh:apps");
      });
    } else {
      document.title = $scope.enterpriseConfig.appName || "";
    }

    $scope.getApps = () => {
      if (!$scope.enterpriseConfig) return [];
      let apps = $scope.enterpriseConfig.appDetails.filter(
        a => a.enterpriseHasApp && a.isUserAuthorized && a.displayOnDashboard
      );
      if (window.isMobile) {
        apps = apps.filter(a => a.isMobileEnabled);
      }
      return apps;
    };

    $scope.getExtraItems = () => {
      if (!$scope.enterpriseConfig) return [];
      return $scope.enterpriseConfig.additionalDashboardItems.slice();
    };

    $scope.goItem = item => {
      if (item.openInNewWindow) {
        window.open(item.href);
      } else {
        window.location.href = item.href;
      }
    };

    // eslint-disable-next-line no-constant-condition
    if (true /*$scope.deviceType !== 'mobile'*/) {
      // TODO
      new Promise(function(resolve, reject) {
        require.ensure(
          ["../news/index.js"],
          function() {
            resolve(require("../news/index.js"));
          },
          "news"
        );
      }).then(function(x) {
        console.warn("Ensure", x);
        return $ocLazyLoad.load({
          name: "msNews"
        });
      });
    }

    $templateCache.put("Dashboard1", require("./views/dashboard1.html"));
    $templateCache.put("Dashboard2", require("./views/dashboard2.html"));
    $templateCache.put("Dashboard3", require("./views/dashboard3.html"));
    $templateCache.put("Dashboard4", require("./views/dashboard4.html"));
    $scope.getDashboardTemplate = () => {
      return "Dashboard" + $rootScope.appLayout.dashboardTemplate;
    };

    $scope.showNews = () => $rootScope.appLayout.showNewsOnDashboard;

    if ($scope.showNews()) {
      $scope.homeLoaded = window.homeLoaded || false;
      $scope.loading = !$scope.homeLoaded;
      $scope.onFeedLoaded = () => {
        $scope.$applyAsync(() => {
          $scope.homeLoaded = true;
          $scope.loading = false;
        });
        window.homeLoaded = true;
      };
    } else {
      $scope.homeLoaded = window.homeLoaded = true;
    }

    // Redirect to custom entry point if set
    const { userEntryPoint } = $rootScope.enterpriseConfig;
    if (
      userEntryPoint &&
      !$rootScope.sentToEntryPoint &&
      ["/", ""].includes($rootScope.initialPath)
    ) {
      $rootScope.sentToEntryPoint = true;
      window.location.hash = userEntryPoint.replace("#", "");
    }
  }
];

window.app.config([
  "$stateProvider",
  "$urlRouterProvider",
  function($stateProvider, $urlRouterProvider) {
    window.getRoutingHelper($stateProvider).state("container", {
      url: "/",
      // // template: template,
      template: require("./index.html"),
      // templateProvider: function() {
      //   var template;
      //   if (window.isMobile) {
      //     template = require("./views/mobile/index.html");
      //   } else {
      //     template = require("./index.html");
      //   }
      //   return template;
      // },
      controllerProvider: [
        "module",
        function(module) {
          return module.controller;
        }
      ],
      resolve: {
        module: [
          function() {
            return {
              controller: ContainerCtrl,
              controllerAs: "Container"
            };
          }
        ]
      },
      animation: {
        enter: "fade-view",
        leave: "fade-view"
      }
    });

    $urlRouterProvider.otherwise(function($injector, $location) {
      // console.log('otherwise');
      // debugger;
      // console.log('on otherwise', { $location, '$location.path()': $location.path() });
      // return $location.path(); // '/';
      // debugger;
      var $state = $injector.get("$state");

      var path = $location.path().split("/");
      if (path[1] && path[1].indexOf(".") === -1) {
        // alert('path-nodots - ', JSON.stringify({ path, s1: $state.get(path[1]), s2: $state.get(path[1] + '-async') }))

        var state = $state.get(path[1]) || $state.get(path[1] + "-async");
        if (
          state &&
          state.params &&
          state.params.$app &&
          state.params.$app.otherwise
        ) {
          if (state.params.$app.otherwiseFn) {
            var match = $injector.invoke(state.params.$app.otherwiseFn);
            if (match) {
              return match;
            }
          }
          return state.params.$app.otherwise;
        }
      }

      if ($state.params.$app && $state.params.$app.otherwise) {
        return $state.params.$app.otherwise;
      }

      return "/";
    });
  }
]);



// WEBPACK FOOTER //
// ./src/apps/container/index.js